import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IDropshippingRequestProductSchemaPartial } from '../../type/dropshippingRequestProduct';
import { IBatchUpdateCustomPriceDropshippingRequestProductSubTypeInput } from '../../type/_inputTypes/batchUpdateCustomPriceDropshippingRequestProduct';

export interface IBatchUpdateCustomPriceDropshippingProductRequestMutationFields {
  batchUpdateCustomPriceDropshippingProductRequests: IBatchUpdateCustomPriceDropshippingRequestProductSubTypeInput[]
}


export interface IBatchUpdateCustomPriceDropshippingProductRequestMutationResponseFields {
  updatedDropshippingProductRequests: IDropshippingRequestProductSchemaPartial[];
}



export function batchUpdateCustomPriceDropshippingProductRequestMutation(fragment: string): DocumentNode {
  return gql`
        mutation batchUpdateCustomPriceDropshippingProductRequest (
        $batchUpdateCustomPriceDropshippingProductRequests: [BatchUpdateCustomPriceDropshippingRequestProductSubTypeInput]!
        ) {
        batchUpdateCustomPriceDropshippingProductRequest (
        batchUpdateCustomPriceDropshippingProductRequests: $batchUpdateCustomPriceDropshippingProductRequests
        ) {
        ...fragment
        }
        }
        fragment fragment on BatchUpdateCustomPriceDropshippingProductRequestMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useBatchUpdateCustomPriceDropshippingProductRequestMutation<TData extends Partial<IBatchUpdateCustomPriceDropshippingProductRequestMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ batchUpdateCustomPriceDropshippingProductRequest: TData },
        IBatchUpdateCustomPriceDropshippingProductRequestMutationFields>,
) {
  return useMutation<{ batchUpdateCustomPriceDropshippingProductRequest: TData },
      IBatchUpdateCustomPriceDropshippingProductRequestMutationFields>(
        batchUpdateCustomPriceDropshippingProductRequestMutation(fragment), options,
      );
}
